// TODO: Implement download controller
import HttpClient from '../httpClient';

class DownloadController extends HttpClient {
  getPresignedUrl = async (
    filePath: string,
    token: string,
    expiresInSeconds = 1000,
    fileName?: string,
  ) => {
    const response = await this.client.get(
      `/download/presigned-url/${filePath}`,
      {
        params: { expiresIn: expiresInSeconds, fileName },
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };
}

export default new DownloadController(process.env.REACT_APP_API_URL_ENTERPRISE);
